import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ProfileSyncData } from '../model/ProfileSyncData';
import { handleError, retryStrategy, api } from '../../shared/api-loaders';
import { retryWhen, map } from 'rxjs/operators';
import { ConversionCorporation } from '../model/ConversionCorporation';
import { Transaction, TransactionFailedRecord, TransactionStatusOptions } from '../model/Transaction';

@Injectable({
  providedIn: 'root'
})
export class ProfileSyncService {

  constructor(private _http: HttpClient) {
  }
  
  public getTransactions() {
    return this._http.get<Transaction[]>(api.profileSync()).pipe(
      retryWhen(retryStrategy()));
  }
  public getFailedUsers(processId) {
    return this._http.get<TransactionFailedRecord[]>(api.profileSyncFailedUsers(processId)).pipe(
      retryWhen(retryStrategy()));
  }
  public sync(data: ProfileSyncData) {
    return this._http.post(api.profileSync(), data).pipe(
      retryWhen(retryStrategy()));
  }

  public syncPhysicianNppa(data: ProfileSyncData) {
    return this._http.post(api.profileSyncPhysicianNppa(), data).pipe(
      retryWhen(retryStrategy()));
  }

  public getCorporations(environmentId: number) {
    return this._http.get<ConversionCorporation[]>(api.corporations(environmentId)).pipe(
      retryWhen(retryStrategy()));
  }
  

}
